import { motion } from "framer-motion";

/**
 * Masked line-by-line reveal.
 * Pass an array of strings, one per visual line.
 */
export default function RevealLines({
  lines,
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.12,
}) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="vv-mask">
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1.1,
              ease: [0.19, 1, 0.22, 1],
              delay: delay + i * stagger,
            }}
            className={`inline-block ${lineClassName}`}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
